import {
    BRAND_DELETE_OPEN_MODAL,
    BRAND_DELETE_REQUEST,
    BRAND_DELETE_RESULT,
} from 'Redux/actionTypes';

export const brandDeleteOpenModal = (brand) => ({
    type: BRAND_DELETE_OPEN_MODAL,
    payload: { brand }
})

export const brandDeleteRequest = (data) => ({
    type: BRAND_DELETE_REQUEST,
    payload: data
})

export const brandDeleteResult = (data) => ({
    type: BRAND_DELETE_RESULT,
    payload: data
})